import { type InfiniteData, type QueryClient } from 'react-query'

import { type IInfinitePage } from 'types/interfaces/ITypes'

const updatePostLikeCache = async (
    postId: string,
    dataQuery: any,
    queryClient: QueryClient
) => {
    const cachedData =
        queryClient.getQueryData<InfiniteData<IInfinitePage>>(dataQuery)
    if (cachedData) {
        const newData = {
            ...cachedData,
            pages: cachedData.pages.map(singleFeedPage => {
                return {
                    ...singleFeedPage,
                    page: {
                        ...singleFeedPage.page,
                        data: {
                            ...singleFeedPage.page.data,
                            data: singleFeedPage.page.data.data.map(post =>
                                post.id === postId
                                    ? {
                                          ...post,
                                          isLiked: !post.isLiked,
                                          likes_count: !post.isLiked
                                              ? post.likes_count + 1
                                              : post.likes_count - 1
                                      }
                                    : post
                            )
                        }
                    }
                }
            })
        }

        queryClient.setQueryData(dataQuery, newData)
    }
    return { cachedData }
}

export { updatePostLikeCache }
